import React, { useEffect } from "react"
import { Field } from "ui"
import { useNode } from "../node"
import { useScreen } from "lib"
import { realPath } from "lib/util"
import { TimelineMax, TweenMax, Elastic, Linear, Expo } from "gsap"

const Intro = ({ domRef, info, value, children, ...props }) => {
    const [open, setOpen] = React.useState(-1)
    const run = React.useRef()
    const first = useNode("first")
    const screen = useScreen()

    useEffect(() => {
        if (run.current) return
        if (!first) {
            document.querySelector("[type-intro]").classList.add("loaded")
            /*document.querySelectorAll(".sections>div").forEach(section => {
                section.style.opacity = 1
            })*/
            document.querySelector(".slogan").style.opacity = 1
            return
        }

        const t = new TimelineMax()
        t.pause()
        let w = 400
        let wEnd = 120
        let marginLogo = 15
        let padding = 15
        if (screen.W <= 900) {
            w=300
            wEnd = 40
            marginLogo = 5
            padding = 5
            if (screen.O==='portrait') wEnd = 90
        }
        if (screen.W <= 600) {
            w=150
            wEnd = 60
            marginLogo = 5
            padding = 5
        }
        if (screen.W <= 400) {
            w=150
            wEnd = 60
            marginLogo = 5
            padding = 5
        }
        t.set("#logo", {
            transition: "none",
            opacity: 0,
            left: 0,
            top: 0,
            x: screen.W / 2 - w / 2,
            y: screen.H / 2 - w / 2,
            width: w,
            scale: 0.05,
            padding: 0
        })

        t.set(".slogan", { opacity: 1, y: 200, skewY: 30 })
        let delta = 1
        t.add(TweenMax.to("#logo", 3, { opacity: 1 }))

        t.add(TweenMax.to("#logo", 1.5, { scale: 1.1, ease: Linear.easeNone }), delta - 1)
        t.add(
            TweenMax.fromTo(
                "#logo #logo-mpi .st1",
                0.5,
                { y: 200 },
                { y: 0, ease: Linear.easeNone }
            ),
            delta
        )
        delta += 0.5

        t.add(TweenMax.to("#logo", 0.3, { scale: 1, ease: Linear.easeNone }), delta)
        delta += 0.3

        t.add(TweenMax.to("#logo", 0.7, { scale: 0.7, ease: Linear.easeNone }), delta)
        delta += 0.7

        t.add(
            TweenMax.fromTo(
                "#logo .romb",
                2,
                { rotation: 0, transformOrigin: "50% 52%" },
                { rotation: 90, transformOrigin: "50% 52%", ease: Elastic.easeOut.config(2, 0.3) }
            ),
            delta
        )
        delta += 1
        t.add(TweenMax.to("#header .header-in", 1,
                          { opacity: 1,
                            onComplete: () => {
                            }
                          }), delta)

        t.add(TweenMax.to(".slogan", 0.5, { y: 0 }), delta + 1.2)
        t.add(TweenMax.to(".slogan", 1, { skewY: 0, ease: Expo.easeOut }), delta + 1.2)

        t.add(TweenMax.to("#logo", 1.7,
                          { scale: 1, width: wEnd, x: 0, y: 0,left:marginLogo, top:marginLogo,padding,
                            onComplete: () => {
                                document.getElementById("header").classList.add('loaded')
                                setTimeout(() => {
                                    document.getElementById("logo").removeAttribute('style')

                                }, 1000)
                            }}), delta)
        t.add(
            TweenMax.to(".introbg video", 0.5, {
                opacity: 0,
                onComplete: () => {
                    run.current = true
                    document.querySelector("[type-intro]").classList.add("loaded")
                    const v = document.querySelector(".introbg video")
                    v.pause()
                },
            }),
            delta + 3
        )
        t.add(TweenMax.to(".introbg", 1, { opacity: 0 }), delta + 4)

        t.play()
        
    }, [run, screen, first])

    const onSelect = (i) => () => {
        setOpen(i)
    }
    
    return (
        <div ref={domRef} {...props}>
            {first && (
                <div className="introbg">
                    <video autoPlay loop muted playsInline>
                        <source src={realPath("/upload/particles.mp4")} type="video/mp4" />
                    </video>
                </div>
            )}
            <div className="sections">
                {value.sections.map((s, i) => (
                    <Field key={i} info={info} field={`sections.${i}`} open={screen.W<800 && open===i} onSelect={onSelect(i)}/>
                ))}
            </div>
            <div className="slogan">
                <strong>QUALITY</strong> IS KEY
            </div>
        </div>
    )
}
export default Intro
/*
            <div className="curtain1" />
            <div className="curtain2" />
*/
